<template>
	<div class="modal-card large">
		<div class="modal-card-head">
			<div class="modal-card-title">{{ Operation }} Portfolio</div>
			<div class="modal-close-button" @click="$emit('close')"></div>
		</div>
		<div class="modal-card-body">
			<div class="columns">
				<div class="column">
					<b-field><b-input type="text" placeholder="Name" v-model="portfolio.Name"></b-input></b-field>
					<b-field><b-input type="textarea" placeholder="Description" v-model="portfolio.Description"></b-input></b-field>
				</div>
			</div>
		</div>
		<div class="modal-card-foot">
			<b-button class="is-secondary" @click="$parent.close()">Cancel</b-button>
			<b-button class="is-primary" @click="savePortfolio">Save</b-button>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			Portfolio: Object
		},
		data() {
			return {
				portfolio: {}
			}
		},
		created() {
			if (this.Portfolio && this.Portfolio.Id) {
				this.portfolio = JSON.parse(JSON.stringify(this.Portfolio));
			}
		},
		computed: {
			Operation() {
				if (this.Portfolio && this.Portfolio.Id)
					return "Edit";
				else
					return "Add";
			}
		},
		methods: {
			savePortfolio() {
				this.$http.post("api/portfolio", this.portfolio)
					.then(async resp => {
						if (resp.data.Id && resp.data.Name) {
							this.$buefy.toast.open("Saved Portfolio.")
							this.$emit('refreshPortfolio', this.portfolio);
							if (this.Operation == "Add") {
								this.$router.push("/portfolio/manage/" + resp.data.Id);
							}
							this.$parent.close();
						}

					})
			}
		}
	}
</script>
